import { render, staticRenderFns } from "./datos-incorrectos.vue?vue&type=template&id=20199a6b&scoped=true&"
import script from "./datos-incorrectos.vue?vue&type=script&lang=js&"
export * from "./datos-incorrectos.vue?vue&type=script&lang=js&"
import style0 from "./datos-incorrectos.vue?vue&type=style&index=0&id=20199a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20199a6b",
  null
  
)

export default component.exports